<pk-broker-modal>
	<ng-template #headerTemplate>
		<h5 class="modal-title">Select Contract</h5>
	</ng-template>
	<ng-template #bodyTemplate>
		<pk-broker-lookup-contract (selectedContract)="selectContract($event)" [initialValue]="initialValue" [initialCriteria]="initialCriteria">
		</pk-broker-lookup-contract>
	</ng-template>
</pk-broker-modal>
